// "há 3 minutos", "há 2 horas", "há 5 dias", "em 2 horas".
// Retorna string pt-BR. Aceita Date, ISO string ou timestamp.
export function formatRelativeTime(input) {
  if (!input) return '';
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();
  const absMs = Math.abs(diffMs);
  const inFuture = diffMs < 0;

  const SEC = 1000;
  const MIN = 60 * SEC;
  const HOUR = 60 * MIN;
  const DAY = 24 * HOUR;
  const WEEK = 7 * DAY;
  const MONTH = 30 * DAY;
  const YEAR = 365 * DAY;

  const unit = (value, singular, plural) =>
    `${value} ${value === 1 ? singular : plural}`;

  let relative;
  if (absMs < 30 * SEC) relative = 'agora há pouco';
  else if (absMs < MIN) relative = unit(Math.round(absMs / SEC), 'segundo', 'segundos');
  else if (absMs < HOUR) relative = unit(Math.round(absMs / MIN), 'minuto', 'minutos');
  else if (absMs < DAY) relative = unit(Math.round(absMs / HOUR), 'hora', 'horas');
  else if (absMs < WEEK) relative = unit(Math.round(absMs / DAY), 'dia', 'dias');
  else if (absMs < MONTH) relative = unit(Math.round(absMs / WEEK), 'semana', 'semanas');
  else if (absMs < YEAR) relative = unit(Math.round(absMs / MONTH), 'mês', 'meses');
  else relative = unit(Math.round(absMs / YEAR), 'ano', 'anos');

  if (relative === 'agora há pouco') return relative;
  return inFuture ? `em ${relative}` : `há ${relative}`;
}

// Formata absoluto pt-BR. "23/04/2026 14:30".
export function formatDateTime(input) {
  if (!input) return '';
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

// Só a data: "23/04/2026".
export function formatDate(input) {
  if (!input) return '';
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('pt-BR').format(date);
}
